import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router'

import { getInitialPlayheadPosition, resetWatchHistory } from './utils'
import { useAppDispatch, useAppSelector } from '../../hooks/useStore'
import ResumeWatchingModal from '../../components/ResumeWatchingModal/ResumeWatchingModal'
import VideoPlayer from '../../components/VideoPlayer/VideoPlayer'

function VideoPlayerContainer() {
  const videoDetails = useAppSelector((state) => state.content.videoDetails)
  const initialPlayheadPosition = getInitialPlayheadPosition(
    videoDetails.seconds_watched,
    videoDetails.duration
  )
  const dispatch = useAppDispatch()
  const navigate = useNavigate()
  const watchedPercent =
    (videoDetails.seconds_watched / videoDetails.duration) * 100
  const [showResumeWatching, setShowResumeWatching] = useState(false)
  const [showVideoPlayer, setShowVideoPlayer] = useState(false)

  useEffect(() => {
    if (videoDetails.seconds_watched < 30 || watchedPercent > 95) {
      setShowVideoPlayer(true)
    } else {
      setShowResumeWatching(true)
    }
  }, [initialPlayheadPosition, watchedPercent])

  const handleResumeWatching = () => {
    setShowVideoPlayer(true)
    setShowResumeWatching(false)
  }

  const handlePlayFromBeginning = () => {
    const newVideoDetails = { ...videoDetails, seconds_watched: 0 }
    dispatch({
      type: 'SET_VIDEO_DATA',
      payload: { videoDetails: newVideoDetails },
    })
    resetWatchHistory(newVideoDetails.videoId)
    setShowVideoPlayer(true)
    setShowResumeWatching(false)
  }

  return (
    <>
      {showResumeWatching && (
        <ResumeWatchingModal
          onResumeWatching={handleResumeWatching}
          onPlayFromBeginning={handlePlayFromBeginning}
          onBackPress={() => navigate(-1)}
        />
      )}
      {showVideoPlayer && (
        <VideoPlayer initialPlayheadPosition={initialPlayheadPosition} />
      )}
    </>
  )
}

export default VideoPlayerContainer
